import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

import "react-virtualized/styles.css";

window.addEventListener("storage", () => {
  window.location.reload();
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
